export const FULL_ACCESS_ROLES = ["admin", "super-admin"];
export const CONTACT_ACCESS_ROLES = ["admin", "super-admin", "hr"];
export const JOB_ACCESS_ROLES = ["admin", "super-admin", "hr"];
export const CONTENT_ACCESS_ROLES = [
  "admin",
  "super-admin",
  "digital marketing",
];

export const getDefaultRouteForRole = (role) => {
  if (role === "hr") {
    return "/jobpost";
  }

  if (role === "digital marketing") {
    return "/allblogs";
  }

  return "/";
};
